import { APIMethod, fetchData } from "@client";
import { mapKeysToCamelCase } from "@client/api/utils/fetchApiUtils";
import { unzip } from "@repo/utils";

export async function getCompanyRateCardQuery(excludeRoles) {
  const res = await fetchData("/company/rate-card", APIMethod.GET, {
    params: {
      excludeRoles
    },
  });
  
  try {
    // return res.results?.categories;
    const categories = typeof res.results?.categories === "string"
      ? mapKeysToCamelCase(JSON.parse(unzip(res.results?.categories)))
      : (res.results?.categories || []);
      
    return categories?.map(category => ({
      ...category.tag,
      categoryId: category.id,
      salesRate: category.salesRate,
      costRate: category.costRate,
      hidden: !category.isActive,
      removable: category.removable,
      order: category.sortOrder,
      roles: category.roles,
    }));
  } catch(e) {
    return []
  }
}
